import { withoutUndoManager } from './without-undo-manager';

export const clearPropertyValueOnModel = (diagram: go.Diagram, propertyName: string, propertyValue: unknown) => {
  const nodes = diagram.model.nodeDataArray.filter((x) => x[propertyName] === propertyValue);
  const links = (diagram.model as go.GraphLinksModel).linkDataArray.filter((x) => x[propertyName] === propertyValue);

  const newValue = !!propertyValue === propertyValue ? false : null;

  withoutUndoManager(diagram, () => {
    while (nodes.length) {
      diagram.model.set(nodes.pop()!, propertyName, newValue);
    }
    while (links.length) {
      diagram.model.set(links.pop()!, propertyName, newValue);
    }
  });
};
